import React from "react";

import { AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { Show } from "../../models/Shows";
import { LeagueChallengeQuestions } from "../../models/ChallengeQuestions";
import { League } from "../../models/Leagues";
import { Cast } from "../../models/Cast";

import { CastAnswer } from "../organisms/AnswerChallengeQuestions";
import ScoreValue from "../atoms/ScoreValue";
import { QuestionAccordionStyled } from "../atoms";
import AnswerQuestionOptionList from "../organisms/AnswerQuestionOptionList";
import QuestionAnswer from "../atoms/QuestionAnswer";

interface AnswerQuestionListProps {
    questions: LeagueChallengeQuestions[];
    answers: CastAnswer[];
    league: League;
    show: Show;
    onSelect: (question: LeagueChallengeQuestions, cast: Cast) => void;
    type: "episode" | "season";
}

const AnswerQuestionList: React.FC<AnswerQuestionListProps> = ({
    questions,
    league,
    show,
    answers,
    onSelect,
    type,
}) => {
    const seasonLockEpisode = league ? league.episode_started + 1 : 2;
    const disabled =
        show.locked ||
        (type === "season" && show.current_episode > seasonLockEpisode);

    return (
        <>
            {questions &&
                questions.map((question, key) => {
                    const answer = answers.find((a) => {
                        return (
                            a.question_id.toString() ===
                            question.question_id.toString()
                        );
                    });

                    return (
                        <QuestionAccordionStyled disableGutters key={key}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <div className="m-2">
                                    <div style={{ fontSize: 18 }}>
                                        {question.description}{" "}
                                        <ScoreValue score={question.score} />
                                    </div>
                                    <QuestionAnswer answer={answer} />
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <AnswerQuestionOptionList
                                    question={question}
                                    league={league}
                                    show={show}
                                    answer={answer}
                                    disabled={disabled}
                                    onSelect={(player: Cast) =>
                                        onSelect(question, player)
                                    }
                                />
                            </AccordionDetails>
                        </QuestionAccordionStyled>
                    );
                })}
        </>
    );
};

export default AnswerQuestionList;
